import * as yup from 'yup';

export const scheduleSchema = yup.object({
  publishType: yup
    .string()
    .oneOf(['now', 'scheduled'], 'Selecione uma opção')
    .optional(),
  withoutEndDate: yup.boolean().optional(),
  scheduledDate: yup
    .mixed()
    .nullable()
    .when('publishType', {
      is: 'scheduled',
      then: schema => schema.required('A data de lançamento é obrigatória'),
      otherwise: schema => schema.optional().nullable(),
    }),
  scheduledTime: yup
    .mixed()
    .nullable()
    .when(['publishType', 'withoutEndDate'], {
      is: (publishType: string, withoutEndDate?: boolean) =>
        publishType === 'scheduled' && !withoutEndDate,
      then: schema => schema.required('A hora de lançamento é obrigatória'),
      otherwise: schema => schema.optional().nullable(),
    }),
});

export type ScheduleFormData = yup.InferType<typeof scheduleSchema>;

export const scheduleDefaultValues: ScheduleFormData = {
  publishType: undefined as unknown as 'now' | 'scheduled',
  scheduledDate: undefined,
  scheduledTime: undefined,
  withoutEndDate: true,
};
